import { List } from 'immutable';

function getMessages(state, count) {
  return state.getIn(['report', 'messages'], List()).slice(0, count);
}

const queries = { getMessages };

export default queries;
